import { gql } from '@apollo/client';

export const fetchMessageChannelTypes = gql`
  query getMessageChannelTypes($search: String!) {
    channelMessageTypes(search: $search) {
      id
      name
      channelType
      messageMedium
      messageTypes {
        id
        name
      }
    }
  }
`;
